import { Routes } from '@angular/router';
import {DownloadComponent} from './purchase-download/purchase-download.component';
import {PurchaseComponent} from './purchase/purchase.component';
import {PurchaseCompleteComponent} from './purchase-complete/purchase-complete.component';

export const routes: Routes = [
    { path: '', redirectTo: '/album', pathMatch: 'full' },
    {
        path: 'album',
        loadComponent: () => import('./album/album.component').then(m => m.AlbumComponent)
    },
    {
      path: 'album/:albumKey',
      loadComponent: () => import('./album/album.component').then(m => m.AlbumComponent)
    },
    {
      path: 'view/:albumId',
      loadComponent: () => import('./albumview/albumview.component').then(m => m.AlbumviewComponent)
    },
    {
        path: 'cookie-policy',
        loadComponent: () => import('./legal/cookie-policy.component').then((m) => m.CookiePolicyComponent),
        title: 'Cookie Policy',
    },
    {
        path: 'privacy-policy',
        loadComponent: () => import('./legal/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
        title: 'Privacy Policy',
    },
    {
        path: 'person/:nameFragment',
        loadComponent: () => import('./person/person.component').then((m) => m.PersonComponent),
        title: 'Find personer',
    },
    {
        path: 'person',
        loadComponent: () => import('./person/person.component').then((m) => m.PersonComponent),
        title: 'Find personer',
    },
    {
        path: 'personalbums',
        loadComponent: () => import('./person/person.component').then((m) => m.PersonComponent),
        title: 'Person',
    },
    {
        path: 'personalbums/:personId',
        loadComponent: () => import('./personalbums/person-albums.component').then((m) => m.PersonAlbumsComponent),
        title: 'Person',
    },
    { path: 'purchase/complete', component: PurchaseCompleteComponent },
    { path: 'purchase/:assetId', component: PurchaseComponent },
    { path: 'download/:token', component: DownloadComponent },
    { path: '**', redirectTo: '/album' },
];
